import { render } from "./bookingDetail.vue?vue&type=template&id=790ff241&scoped=true&ts=true"
import script from "./bookingDetail.vue?vue&type=script&lang=ts"
export * from "./bookingDetail.vue?vue&type=script&lang=ts"

import "./bookingDetail.vue?vue&type=style&index=0&id=790ff241&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790ff241"]])

export default __exports__